import { Amplify } from 'aws-amplify';
import { config, getCurrentEnvironment } from './environment';
import { loggers } from '../utils/logger';

// Debug logging for configuration (only once)
if (!window.__COGNITO_DEBUG_LOGGED) {
  loggers.auth.log('Amplify Configuration:', {
    environment: getCurrentEnvironment(),
    userPoolId: config.COGNITO_USER_POOL_ID,
    region: config.AWS_REGION,
    apiBaseUrl: config.API_BASE_URL,
    graphqlUrl: config.GRAPHQL_API_URL
  });
  window.__COGNITO_DEBUG_LOGGED = true;
}

// Configure Amplify for Auth (Cognito) and API (AppSync GraphQL)
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.COGNITO_USER_POOL_ID,
      userPoolClientId: config.COGNITO_USER_POOL_CLIENT_ID,
      region: config.AWS_REGION,
      loginWith: {
        username: true,
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: config.GRAPHQL_API_URL,
      region: config.AWS_REGION,
      // Use Cognito User Pool for authentication (matches our existing auth setup)
      defaultAuthMode: 'userPool' as const,
    },
  },
};

// Initialize Amplify with both Auth and API
Amplify.configure(amplifyConfig);

// Legacy export for backward compatibility
export const cognitoConfig = amplifyConfig;
export default amplifyConfig; 